/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import { ReservationPointsOfSale, ReservationStatuses } from '../constants';
import { PassInfoDefaults, PassInfoProps } from './passInfo';
import { ShippingDefaults, ShippingProps } from './shipping';

export const ReservationProps = PropTypes.shape({
    id: PropTypes.string,
    account_id: PropTypes.string,
    order_id: PropTypes.string,
    pass_type_id: PropTypes.string,
    reservation_number: PropTypes.string,
    pass_info: PassInfoProps,
    pass_cost: PropTypes.number,
    quantity: PropTypes.number,
    clin: PropTypes.number,
    pass_sku: PropTypes.string,
    location_id: PropTypes.string,
    location: PropTypes.string,
    rec_area: PropTypes.string,
    pos: PropTypes.oneOf(ReservationPointsOfSale),
    status: PropTypes.oneOf(ReservationStatuses),
    valid_at: PropTypes.string,
    expires_at: PropTypes.string,
    shipping: ShippingProps,
    updated_at: PropTypes.string,
});

export const ReservationDefaults = {
    id: null,
    account_id: null,
    order_id: null,
    pass_type_id: null,
    reservation_number: null,
    pass_info: PassInfoDefaults,
    pass_cost: 0,
    clin: 0,
    pass_sku: '',
    location_id: '',
    location: '',
    rec_area: '',
    valid_at: gnoment().format(),
    expires_at: gnoment().add(12, 'months').endOf('month').format(),
    pos: 'web',
    status: 'pending',
    created_at: null,
    shipping: ShippingDefaults,
    updated_at: null,
};
